import {withComponent} from '../../hoc/withComponent';
import {TableHeadBase} from './TableHeadBase';

export const withTableHead = withComponent(TableHeadBase);
